export var IdGameTrackingClientFunnelState;
(function (IdGameTrackingClientFunnelState) {
    IdGameTrackingClientFunnelState["LOADING_STEP_APP_START"] = "LOADING_STEP_APP_START";
    IdGameTrackingClientFunnelState["LOCALIZATION_START"] = "LOCALIZATION_START";
    IdGameTrackingClientFunnelState["LOCALIZATION_END"] = "LOCALIZATION_END";
    IdGameTrackingClientFunnelState["SERVER_CONNECTION_START"] = "SERVER_CONNECTION_START";
    IdGameTrackingClientFunnelState["SERVER_CONNECTION_END"] = "SERVER_CONNECTION_END";
    IdGameTrackingClientFunnelState["LOGIN_START"] = "LOGIN_START";
    IdGameTrackingClientFunnelState["LOGIN_END"] = "LOGIN_END";
    IdGameTrackingClientFunnelState["PLAYER_BASE_SHOW"] = "PLAYER_BASE_SHOW";
    IdGameTrackingClientFunnelState["PLAY_TIME_X_MINUTE"] = "PLAY_TIME_{X}_MINUTE";
    IdGameTrackingClientFunnelState["TUTORIAL_START"] = "TUTORIAL_START";
    IdGameTrackingClientFunnelState["welcome_clickConfirmButton"] = "01a_welcome_tapConfirmButton";
    IdGameTrackingClientFunnelState["harvestCorn_clickAcre"] = "02a_harvestCorn_tapAcre";
    IdGameTrackingClientFunnelState["sowWildflowers_clickAcre"] = "03a_sowWildflowers_tapAcre";
    IdGameTrackingClientFunnelState["sowWildflowers_clickOnRecipe"] = "03b_sowWildflowers_tapOnRecipe";
    IdGameTrackingClientFunnelState["sowWildflowers_clickStartProduction"] = "03c_sowWildflowers_tapStartProduction";
    IdGameTrackingClientFunnelState["constructWindmill_clickBuildMenu"] = "04a_constructWindmill_tapBuildMenu";
    IdGameTrackingClientFunnelState["constructWindmill_clickBuyButton"] = "04c_constructWindmill_tapBuyButton";
    IdGameTrackingClientFunnelState["constructWindmill_confirmPlacement"] = "04d_constructWindmill_confirmPlacement";
    IdGameTrackingClientFunnelState["confirmConstruction"] = "05a_confirmConstruction";
    IdGameTrackingClientFunnelState["produceChickenFeed_clickWindmill"] = "06a_produceChickenFeed_tapWindmill";
    IdGameTrackingClientFunnelState["produceChickenFeed_clickStartProduction"] = "06b_produceChickenFeed_tapStartProduction";
    IdGameTrackingClientFunnelState["harvestWildflowers_clickAcre"] = "07a_harvestWildflowers_tapAcre";
    IdGameTrackingClientFunnelState["checkNewQuest_clickQuestMenu"] = "10a_checkNewQuest_tapQuestMenu";
    IdGameTrackingClientFunnelState["checkNewQuest_clickShowMeButton"] = "10b_checkNewQuest_tapShowMeButton";
    IdGameTrackingClientFunnelState["checkNewQuest_clickStartProduction"] = "10c_checkNewQuest_tapStartProduction";
    IdGameTrackingClientFunnelState["collectQuestReward_clickQuestMenu"] = "11a_collectQuestReward_tapQuestMenu";
    IdGameTrackingClientFunnelState["collectQuestReward_clickCollectRewards"] = "11b_collectQuestReward_tapCollectRewards";
    IdGameTrackingClientFunnelState["tutorialEndConfirmation"] = "TUTORIAL_END";
})(IdGameTrackingClientFunnelState || (IdGameTrackingClientFunnelState = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/game-funnel/IdGameTrackingClientFunnelState.ts
// module id = 211
// module chunks = 3